import recommendations from './recommendations';

/**
 *  Render univeral recommendations
 *
 * @param {Object} result - product data to print
 * @returns {string} universal recommendations HTML
 */
export default result => {
    if (!result || !result.products) {
        return '';
    }
    return `
        <div class="js-universal-recommendations universal-recommendations product-include" data-cnstrc-recommendations data-cnstrc-num-results="${
            result.products?.length
        }" data-cnstrc-recommendations-pod-id="${result.pod_id}" data-cnstrc-result-id="${result.result_id}">
            <h2 class="product-include-title">${result.pod_display_name}</h2>
            <div class="product-tiles" data-show-bubbles="true" data-speed="800">
                <div class="xlt-searchresults product-include-inner">
                    <div class="recomm-image-arrows-wrapper recomm-image-arrows-left">
                        <i class="icon icon-arrow_left" aria-hidden="true"></i>
                    </div>
                    <div class="js-slick-universal-recommendations search-result-items tiles-container clearfix hide-compare">
                        ${recommendations(result.products, true)}
                    </div>
                    <div class="recomm-image-arrows-wrapper recomm-image-arrows-right">
                        <i class="icon icon-arrow_right" aria-hidden="true"></i>
                    </div>
                </div>
            </div>
        </div>
    `;
};
